/* Cart-page quantities only. No pricing, consent or attribution configuration. */
(function (w, d) {
  'use strict';
  if (w.NatuCartSync) return;
  var selector = '.natucopos-cart-form [data-ngi-v21-cart-line]';
  var states = new Map(), timer, running = false, sending = false, failed = false;
  function rows() { return Array.from(d.querySelectorAll(selector)); }
  function input(row) { return row.querySelector('input[name="updates[]"]'); }
  function quantity(el) { return /^\d+$/.test(el.value) && Number(el.value) >= 1 && Number(el.value) <= 999999 ? Number(el.value) : null; }
  function state(row) {
    if (!states.has(row)) states.set(row, { confirmed: Number(row.dataset.ngiV21CartQuantity), desired: quantity(input(row)) });
    return states.get(row);
  }
  function dirty() { return rows().some(function (r) { var s = state(r); return quantity(input(r)) === null || quantity(input(r)) !== s.confirmed; }); }
  function blocked() { return running || !!timer || failed || dirty(); }
  function render() {
    var button = d.getElementById('NatucoposSendWhatsapp');
    if (button) button.disabled = sending || blocked();
    rows().forEach(function (r) { input(r).disabled = sending; });
    var form = d.querySelector('.natucopos-cart-form');
    if (!form) return;
    var note = form.querySelector('[data-natu-cart-status]');
    if (!note) { note = d.createElement('p'); note.dataset.natuCartStatus = ''; note.setAttribute('role', 'status'); form.appendChild(note); }
    note.textContent = failed ? 'Não foi possível confirmar a quantidade. Tente novamente antes de enviar.' : blocked() ? 'Atualizando quantidades. Aguarde a confirmação antes de enviar.' : '';
    var retry = form.querySelector('[data-natu-cart-retry]');
    if (!retry) { retry = d.createElement('button'); retry.type = 'button'; retry.dataset.natuCartRetry = ''; retry.textContent = 'Tentar novamente'; form.appendChild(retry); }
    retry.hidden = !failed; retry.disabled = running || sending;
  }
  async function request(path, options) {
    var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); }, 8000);
    try {
      var response = await fetch((w.Shopify && w.Shopify.routes.root || '/') + path, Object.assign({ credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, options));
      if (!response.ok) throw new Error('CART_HTTP_' + response.status);
      var cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('CART_INVALID');
      return cart;
    } finally { clearTimeout(timeout); }
  }
  function matches(cart, row, expected) {
    var key = row.dataset.ngiV21LineKey;
    var found = cart.items.filter(function (item) { return item.key === key; });
    return !!key && found.length === 1 && found[0].quantity === expected;
  }
  function count(cart) {
    var node = d.querySelector('.natucopos-summary-row .item');
    if (node) node.textContent = String(cart.items.reduce(function (sum, item) { return sum + item.quantity; }, 0));
  }
  async function drain() {
    clearTimeout(timer); timer = null;
    if (running || sending) return;
    running = true; failed = false; render();
    try {
      for (;;) {
        var row = rows().find(function (r) { return quantity(input(r)) !== state(r).confirmed; });
        if (!row) break;
        var desired = quantity(input(row)), key = row.dataset.ngiV21LineKey;
        if (desired === null || !key) throw new Error('CART_QUANTITY_OR_KEY_INVALID');
        var cart = await request('cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: desired }) });
        if (!matches(cart, row, desired)) throw new Error('CART_UNCONFIRMED');
        count(cart);
        state(row).confirmed = desired; row.dataset.ngiV21CartQuantity = String(desired);
        // A later edit is retained and serialized after this response; never overwrite its field.
      }
    } catch (_) { failed = true; }
    finally { running = false; render(); }
  }
  function schedule(row) {
    state(row).desired = quantity(input(row));
    clearTimeout(timer); timer = setTimeout(drain, 250); render();
  }
  d.addEventListener('input', function (e) {
    var row = e.target.closest(selector);
    if (row && e.target === input(row)) schedule(row);
  });
  d.addEventListener('change', function (e) {
    var row = e.target.closest(selector);
    if (row && e.target === input(row)) schedule(row);
  });
  d.addEventListener('click', function (e) {
    var retry = e.target.closest('[data-natu-cart-retry]');
    if (retry) { e.preventDefault(); if (!sending) drain(); return; }
    var control = e.target.closest('[data-natu-qty-step]');
    if (!control) return;
    var row = control.closest(selector); if (!row) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (sending) return;
    var field = input(row), current = quantity(field);
    if (current === null) current = state(row).confirmed;
    field.value = String(Math.max(1, Math.min(999999, current + Number(control.dataset.natuQtyStep))));
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);
  async function begin() {
    if (sending || blocked()) throw new Error('CART_NOT_CONFIRMED');
    sending = true; render();
    try {
      var cart = await request('cart.js');
      if (rows().length && (cart.items.length !== rows().length || rows().some(function (r) { return !matches(cart, r, quantity(input(r))); }))) {
        failed = true; throw new Error('CART_CHANGED_RELOAD_REQUIRED');
      }
      count(cart);
      return cart;
    } catch (error) { sending = false; render(); throw error; }
  }
  function end() { sending = false; render(); }
  w.NatuCartSync = Object.freeze({ begin: begin, end: end, blocked: blocked });
  d.addEventListener('DOMContentLoaded', function () { rows().forEach(state); render(); });
})(window, document);
